import { useChartPersistence } from '../hooks';

/**
 * Headless sentinel that runs the per-eval chart-layout persistence (hydrate on load +
 * debounced autosave on change) via {@link useChartPersistence}. It renders nothing, and its
 * `chartsAtom` / `chartGridAtom` subscriptions live HERE — not in the `Eval3NewContent` root
 * — so chart-state churn re-renders only this null node, keeping the map / table / summary
 * out of the loop. Mounted once, unconditionally, in the feature root.
 *
 * @return {null} Nothing — this component is behavior-only.
 */
export function ChartsPersistenceSync(): null {
  useChartPersistence();
  return null;
}
